import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Item from './Item';
import FixiOSBug from './FixiOSBug';
export default {
  name: 'SidebarItem',
  components: {
    Item: Item
  },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    openIframe: function openIframe(item) {
      // let url = item.path.replace('http://172.19.218.187:9533/#/', 'http://localhost:8080/#/')
      // if(item.resourceName === '首页'){
      //   url = null
      // }
      this.$store.dispatch('settings/changeSetting', {
        key: 'index',
        value: item.resourceId
      });
      this.$API.postRequest({
        url: '/platform/app/click/log',
        data: {
          resourceId: item.id,
          url: item.path,
          urlRef: ''
        }
      });
      // const url = item.path.split('#');
      if (item.isAllowOpenPage === 1) {
        window.open(item.path);
        return;
      }
      // if (item.systemId === 'LC_OA') {
      //   // history.pushState('a', '', `${window.location.origin}/dashboard`);
      // } else {
      //   if (item.path) {
      //     // history.pushState('a', '', `${item.path}`);
      //   } else {
      //     // history.pushState('a', '', window.location.origin);
      //   }
      // }

      // window.location.herf = window.location.origin
      // let basecontenturl = url[0];
      sessionStorage.setItem('defaultactivemenu', item.resourceId);
      this.$store.dispatch('settings/changeSetting', {
        key: 'breadcrumb',
        value: item
      });
      this.$store.dispatch('settings/changeSetting', {
        key: 'menuactivehome',
        value: false
      });
      var title = document.getElementsByTagName('title')[0];
      title.innerText = "\u667A\u80FD\u5408\u89C4\u5E73\u53F0";
      var resourcePath = JSON.stringify(item);
      sessionStorage.setItem('resourcePath', resourcePath);
      if (item.systemId === 'LC_PLATFORM') {
        // sessionStorage.removeItem('loadPath')
        this.$store.dispatch('settings/changeSetting', {
          key: 'iframeUrl',
          value: null
        });
        var path = item.path.replace(window.location.origin, '');
        this.$router.push(path);
      } else {
        var _path = item.path;
        if (_path === this.$store.state.settings.iframeUrl) {
          this.$store.dispatch('settings/changeSetting', {
            key: 'iframeKey',
            value: (Math.random() * 100).toString()
          });
        }
        this.$store.dispatch('settings/changeSetting', {
          key: 'iframeUrl',
          value: _path
        });
        this.$router.push({
          query: {
            iframePath: _path
          }
        });
      }
    },
    hasOneShowingChild: function hasOneShowingChild() {
      var _this = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          _this.onlyOneChild = item;
          // console.log("this.onlyOneChild",this.onlyOneChild)
          return true;
        }
      });
      if (parent.parentResourceId === 0 && showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: '',
          noShowingChildren: true,
          isMenuTitle: true
        });
        return true;
      }
      if (parent.parentResourceId === 0) {
        return false;
      }

      // When there is only one child router, the child router is displayed by default
      // if (showingChildren.length === 1) {
      //   return true
      // }
      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: '',
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    resolvePath: function resolvePath() {
      var contenturl = "".concat(this.item.id);
      return contenturl;
    },
    onlyOneChildindex: function onlyOneChildindex() {
      // let contenpath = "" + this.item.path.split("#")[1];
      //   if(contenpath == ''){
      // return this.item.resourceId;
      // }
      return this.item.resourceId;
    }
  },
  computed: {}
};